import Swiper from 'swiper'
import { Pagination, Autoplay } from 'swiper/modules'

import 'swiper/css'

class Testimonials extends HTMLElement {
    constructor() {
        super()

        this.sliderContainer = this.querySelector('.swiper')
        this.videos = Array.from(this.querySelectorAll('video-element video'))

        this.videos.forEach(video => {
            const remainingVids = this.videos.filter(vid => vid !== video)
            video.addEventListener('play', () => {
                remainingVids.forEach(vid => {
                    vid.pause()
                })
            })
        })

        new Swiper(this.sliderContainer, {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 7000
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 3
                }
            },
            on: {
                slideChange: () => {
                    this.videos.forEach(video => {
                        video.pause()
                    })
                }
            }

        })
    }
}

customElements.define('video-testimonials', Testimonials)

export { Testimonials }
